import { usePatientNameContext } from '@context/PatientName';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';

import { NAME_INPUT_VIEW } from '../focuskey';
import ButtonContainer from './components/ButtonContainer';
import Content from './components/Content';
import InputContainer from './components/InputContainer';

import * as styles from './styles';

const PatientNameView = () => {
  const { focusNameInput } = usePatientNameContext();
  const { ref } = useFocusable({ focusKey: NAME_INPUT_VIEW });

  useEffect(() => {
    focusNameInput();
  }, [focusNameInput]);

  return (
    <FocusContext.Provider value={NAME_INPUT_VIEW}>
      <div css={styles.container} ref={ref}>
        <Content />
        <div css={styles.rightSideContainer}>
          <InputContainer />
          <ButtonContainer />
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default PatientNameView;
